import { useContext, useEffect } from 'react'

import Loading from 'components/Loading'
import { useGetWorkspacePrebidConfiguration } from 'features/globalSetup/hooks/useGetWorkspacePrebidConfiguration'
import { DefaultsContext } from 'features/globalSetup/pages/Defaults/DefaultsContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { FormContainer as PrebidStackForm } from './FormContainer'

export const PrebidStackTab = (): JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const { prebidStack } = useContext(DefaultsContext)

  const { workspacePrebidConfiguration: configApi } = useGetWorkspacePrebidConfiguration({
    workspaceId,
  })

  const { setWorkspaceConfig, workspaceConfig } = prebidStack || {}

  useEffect(() => {
    if (configApi && setWorkspaceConfig) {
      setWorkspaceConfig(configApi)
    }
  }, [setWorkspaceConfig, configApi])

  if (!configApi || !workspaceConfig) {
    return <Loading />
  } else {
    return <PrebidStackForm />
  }
}
